var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
// import {TranslateService} from 'ng2-translate';
import { TranslateService } from '@ngx-translate/core';
var ToastrService = /** @class */ (function () {
    function ToastrService(toastr, translate) {
        this.toastr = toastr;
        this.translate = translate;
    }
    ToastrService.prototype.showSuccess = function (msg) {
        var _this = this;
        this.toastr.dispose();
        this.toastr.success(msg, null, { showCloseButton: true, maxShown: 1, dismiss: 'controlled' }).then(function (toast) {
            setTimeout(function () {
                _this.toastr.dismissToast(toast);
            }, 5000);
        });
    };
    ToastrService.prototype.showError = function (msg) {
        var _this = this;
        this.toastr.dispose();
        this.toastr.error(msg, null, { showCloseButton: true, maxShown: 1, dismiss: 'controlled' }).then(function (toast) {
            setTimeout(function () {
                _this.toastr.dismissToast(toast);
            }, 5000);
        });
    };
    ToastrService.prototype.showMqttNotification = function (msg, title) {
        var _this = this;
        this.toastr.success(msg, title, { showCloseButton: true, dismiss: 'controlled' }).then(function (toast) {
            var audio = new Audio('https://assets.deliforce.io/web_notification.mp3');
            audio.play();
            setTimeout(function () {
                _this.toastr.dismissToast(toast);
            }, 5000);
        });
    };
    ToastrService.prototype.serverMsg = function () {
        this.toastMessage = this.translate.get('Toasts.Problem with server please try again later');
        return this.toastMessage.value;
    };
    ToastrService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ToastsManager, TranslateService])
    ], ToastrService);
    return ToastrService;
}());
export { ToastrService };



//////////////////
// WEBPACK FOOTER
// ./src/app/toastr.service.ts
// module id = ./src/app/toastr.service.ts
// module chunks = main